import React, { useState, useEffect, useContext, useRef } from "react";
import { useHistory } from "react-router-dom";
import plusImage1 from "../../Images/plusImage1.png";
import minusImage1 from "../../Images/minusImage1.png";
import deleteImage from "../../Images/deleteImage.png";
import axios from "axios";
import { MyDomain } from "../../App";
import GiftImage from "../../Images/GiftImage.png";
import { useTranslation } from "react-i18next";
import { AppContext, useAppContext } from "../../AppContext";

export default function CheckOutOrderSection({ setPromoCode2, PromoCode2 }) {
  const { User, Token } = useAppContext();

  const [loading1, setLoading1] = useState(true);
  const [error1, setError1] = useState(null);
  const [UserExistInBeautyClub, setUserExistInBeautyClub] = useState(false);
  const [BeautyClubData, setBeautyClubData] = useState("");

  const [error2, setError2] = useState(false);

  const fetchData = async () => {
    console.log("aa");
    if (!User || !Token) {
      setError1("User or Token is missing");
      setLoading1(false);
      return;
    }
    try {
      const response = await axios.get(
        `${MyDomain}BeautyClub/GetUserDatafromBeautyClub?UserId=${user?.userId}`,
        {
          // headers: {
          //   Authorization: `Bearer ${Token}`,
          // },
          params: { Id: User.userId },
        }
      );
      setBeautyClubData(response.data);
      setUserExistInBeautyClub(true);
      console.log(response.data);

      setLoading1(false);
    } catch (err) {
      setBeautyClubData("");

      setUserExistInBeautyClub(false);
      console.log(err.response.data);
      setError1(err.response.data);
      setLoading1(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  const { t, i18n } = useTranslation();
  useEffect(() => {
    const style = document.createElement("style");
    style.textContent = `
            /* Webkit Browsers (Chrome, Safari, Edge) */
            div::-webkit-scrollbar {
              width: 4px;
              height: 4px;
            }
      
            div::-webkit-scrollbar-track {
              background: transparent;
            }
      
            div::-webkit-scrollbar-thumb {
              background: #ccc;
              border-radius: 4px;
            }
      
            div::-webkit-scrollbar-thumb:hover {
              background: #aaa;
            }
      
            div::-webkit-scrollbar-button {
              display: none;
            }
          `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, []);
  const history = useHistory();
  const { CartAmount, setCartAmount } = useContext(AppContext);
  const [SaveTotalPrice, setSaveTotalPrice] = useState(0);
  const [SaveGrandTotalPrice, setSaveGrandTotalPrice] = useState(0);

  const user = JSON.parse(localStorage.getItem("user"));
  const [CartData2, setCartData2] = useState([]);
  useEffect(() => {
    GetCartData();
  }, [PromoCode2]);
  const GetCartData = async () => {
    setCartData2([]);
    const data = {
      UserId: user?.userId,
    };
    axios
      .post(`${MyDomain}Cart/GetUserCart`, data) // replace with your API URL
      .then((response) => {
        console.log(response.data);
        // Extract userCart and products
        const userCart = response.data?.userCart || [];
        const products = response.data?.products || [];
        const beautyClub = response.data?.beautyClub?.discount || null;

        console.log(beautyClub);
        const groupedProducts = {};
        products.forEach((product) => {
          const key = `${product.id}-${product.discount}`;

          if (!groupedProducts[key]) {
            groupedProducts[key] = {
              ...product,
              totalQuantity: 0,
              totalPrice: 0,
              cartIds: [], // To store userCart IDs
            };
          }
          groupedProducts[key].totalQuantity += 1;
          groupedProducts[key].totalPrice += product.PriceAfterDiscount || 0;
        });

        // Step 2: Map cart items to grouped products using idOfProduct
        userCart.forEach((cartItem) => {
          Object.keys(groupedProducts).forEach((key) => {
            if (groupedProducts[key].id === cartItem.idOfProduct) {
              groupedProducts[key].cartIds.push(cartItem.id); // Save userCart.id
            }
          });
        });
        // Convert object to array
        const result = Object.values(groupedProducts);
        // Step 3: Calculate total price of all products
        const total = result.reduce(
          (acc, product) => acc + product.totalPrice,
          0
        );
        // Final Output
        setCartData2(result);
        if (PromoCode2 === null) {
          setSaveGrandTotalPrice(total);
          setSaveTotalPrice(total);
        } else {
          setSaveTotalPrice(total);
          setSaveGrandTotalPrice(total - (total * PromoCode2?.discount) / 100);
        }
        console.log(beautyClub);
        if (beautyClub !== null || beautyClub !== beautyClub) {
          console.log("enter");
          setSaveGrandTotalPrice(total - (total * beautyClub) / 100);
          console.log(total);

          console.log(total - (total * beautyClub) / 100);
        }
      })
      .catch((error) => {
        //setResponseMessage("Error submitting data.");
      });
  };
  const CreateProduct2 = (IdOfProduct) => {
    const data = {
      UserId: user?.userId,
      IdOfProduct: IdOfProduct,
      AmountOfProduct: 1, // Default to adding 1 product to the cart
    };

    axios
      .post(`${MyDomain}Cart/AddProductToCart`, data) // API URL for adding products to the cart
      .then((response) => {
        // Extract userCart and products
        const userCart = response.data?.userCart || [];
        const products = response.data?.products || [];
        const beautyClub = response.data?.beautyClub?.discount || null;
        // Step 1: Group products by `id` and `discount`
        const groupedProducts = {};
        products.forEach((product) => {
          const key = `${product.id}-${product.discount}`;

          if (!groupedProducts[key]) {
            groupedProducts[key] = {
              ...product,
              totalQuantity: 0,
              totalPrice: 0,
              cartIds: [], // To store userCart IDs
            };
          }

          groupedProducts[key].totalQuantity += 1;
          groupedProducts[key].totalPrice += product.PriceAfterDiscount || 0;
        });

        // Step 2: Map cart items to grouped products using idOfProduct
        userCart.forEach((cartItem) => {
          Object.keys(groupedProducts).forEach((key) => {
            if (groupedProducts[key].id === cartItem.idOfProduct) {
              groupedProducts[key].cartIds.push(cartItem.id); // Save userCart.id
            }
          });
        });

        // Convert object to array
        const result = Object.values(groupedProducts);

        // Step 3: Calculate total price of all products
        const total = result.reduce(
          (acc, product) => acc + product.totalPrice,
          0
        );
        setCartData2(result);
        if (PromoCode2 === null) {
          setSaveGrandTotalPrice(total);
          setSaveTotalPrice(total);
        } else {
          setSaveTotalPrice(total);
          setSaveGrandTotalPrice(total - (total * PromoCode2?.discount) / 100);
        }
        if (beautyClub !== null) {
          setSaveGrandTotalPrice(total - (total * beautyClub) / 100);
        }
        setCartAmount(response.data.userCart.length);
      })
      .catch((error) => {});
  };

  const [hoverStates, setHoverStates] = useState({}); // Store hover states for each ID
  const handleMouseEnter = (id) => {
    setHoverStates((prev) => ({ ...prev, [id]: true }));
  };

  const handleMouseLeave = (id) => {
    setHoverStates((prev) => ({ ...prev, [id]: false }));
  };

  const MinusAmountCart = (TheId, UserId, IdOfProduct) => {
    const data = {
      Id: TheId,
      UserId: UserId,
      IdOfProduct: IdOfProduct,
    };
    axios
      .post(`${MyDomain}Cart/MinusAmountCart`, data) // API URL for decrementing the cart amount
      .then((response) => {
        const userCart = response.data?.userCart || [];
        const products = response.data?.products || [];
        const beautyClub = response.data?.beautyClub?.discount || null;
        setCartAmount(userCart.length);
        // Step 1: Group products by `id` and `discount`
        const groupedProducts = {};
        products.forEach((product) => {
          const key = `${product.id}-${product.discount}`;

          if (!groupedProducts[key]) {
            groupedProducts[key] = {
              ...product,
              totalQuantity: 0,
              totalPrice: 0,
              cartIds: [], // To store userCart IDs
            };
          }
          groupedProducts[key].totalQuantity += 1;
          groupedProducts[key].totalPrice += product.PriceAfterDiscount || 0;
        });
        // Step 2: Map cart items to grouped products using idOfProduct
        userCart.forEach((cartItem) => {
          Object.keys(groupedProducts).forEach((key) => {
            if (groupedProducts[key].id === cartItem.idOfProduct) {
              groupedProducts[key].cartIds.push(cartItem.id); // Save userCart.id
            }
          });
        });
        // Convert object to array
        const result = Object.values(groupedProducts);

        // Step 3: Calculate total price of all products
        const total = result.reduce(
          (acc, product) => acc + product.totalPrice,
          0
        );

        // Final Output
        setCartData2(result);
        if (PromoCode2 === null) {
          setSaveGrandTotalPrice(total);
          setSaveTotalPrice(total);
        } else {
          setSaveTotalPrice(total);
          setSaveGrandTotalPrice(total - (total * PromoCode2?.discount) / 100);
        }
        if (beautyClub !== null) {
          setSaveGrandTotalPrice(total - (total * beautyClub) / 100);
        }
      })
      .catch((error) => {});
  };
  const DeleteFromCart = async (
    DelproductId,
    ProductId,
    UserId,
    IdOfProduct
  ) => {
    axios
      .delete(`${MyDomain}Cart/DeleteFromCart`, {
        data: { Id: DelproductId, UserId: UserId, IdOfProduct: IdOfProduct },
      })
      .then((response) => {
        const userCart = response.data?.userCart || [];
        const products = response.data?.products || [];
        const beautyClub = response.data?.beautyClub?.discount || null;
        setCartAmount(userCart.length);
        // Step 1: Group products by `id` and `discount`
        const groupedProducts = {};
        products.forEach((product) => {
          const key = `${product.id}-${product.discount}`;

          if (!groupedProducts[key]) {
            groupedProducts[key] = {
              ...product,
              totalQuantity: 0,
              totalPrice: 0,
              cartIds: [], // To store userCart IDs
            };
          }
          groupedProducts[key].totalQuantity += 1;
          groupedProducts[key].totalPrice += product.PriceAfterDiscount || 0;
        });
        // Step 2: Map cart items to grouped products using idOfProduct
        userCart.forEach((cartItem) => {
          Object.keys(groupedProducts).forEach((key) => {
            if (groupedProducts[key].id === cartItem.idOfProduct) {
              groupedProducts[key].cartIds.push(cartItem.id); // Save userCart.id
            }
          });
        });
        // Convert object to array
        const result = Object.values(groupedProducts);

        // Step 3: Calculate total price of all products
        const total = result.reduce(
          (acc, product) => acc + product.totalPrice,
          0
        );

        // Final Output
        setCartData2(result);
        if (PromoCode2 === null) {
          setSaveGrandTotalPrice(total);
          setSaveTotalPrice(total);
        } else {
          setSaveTotalPrice(total);
          setSaveGrandTotalPrice(total - (total * PromoCode2?.discount) / 100);
        }
        if (beautyClub !== null) {
          setSaveGrandTotalPrice(total - (total * beautyClub) / 100);
        }
      })
      .catch((error) => {});
  };
  const calculateTotalPrice = (price, amount, discount, discountOnEvery) => {
    let total = 0;

    for (let i = 1; i <= amount; i++) {
      if (i % discountOnEvery === 0) {
        // Apply discount to every 'discountOnEvery' item
        total += price * (1 - discount / 100);
      } else {
        // Add full price for non-discounted items
        total += price;
      }
    }
    // Format the total to show decimals only when needed
    const formattedTotal = Number.isInteger(total)
      ? total.toString()
      : parseFloat(total.toFixed(2));
    return formattedTotal;
  };

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        border: "0.1px solid #e4e4e7",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div
          style={{
            flexDirection: "row",
            display: "flex",
            width: "90%",
            alignItems: "center",
            justifyContent: "space-between",
            paddingTop: 20,
            paddingBottom: 20,
          }}
        >
          <p style={{ margin: 0, fontWeight: "500", fontSize: 20 }}>
            {t("profile.Yourorders")}
          </p>
          <p style={{ margin: 0, fontWeight: "500", fontSize: 20 }}>
            ₪{SaveTotalPrice.toFixed(2)}
          </p>
        </div>

        <div
          style={{
            width: "90%",
            backgroundColor: "#e4e4e7",
            height: "1px",
          }}
        ></div>
      </div>
      <div
        style={{
          height: 550,
          overflow: "auto", // Enables scrolling
          width: "100%",
        }}
      >
        {CartData2.map((product) => {
          return (
            <div style={{}}>
              <div
                key={product.id}
                style={{
                  width: "100%",
                  paddingBottom: "5px",
                  flexDirection: "column",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    cursor: "pointer",
                    width: "100%",
                  }}
                >
                  <img
                    src={product.image}
                    style={{
                      width: 150,
                      height: "100%",
                      cursor: "pointer",
                    }}
                  />
                  <div
                    style={{
                      width: "100%",
                    }}
                  >
                    <p
                      style={{
                        padding: 0,
                        marginBottom: 5,
                        fontSize: 15,
                      }}
                    >
                      {product.name}
                    </p>
                    <p style={{ padding: 0, margin: 0, opacity: 0.5 }}>
                      {product.productType}
                    </p>
                    <p style={{ padding: 0, margin: 0, opacity: 0.5 }}>
                      {product.dropDown}
                    </p>
                    {product.isGift === 2 ? (
                      <>
                        <img
                          src={GiftImage}
                          style={{
                            width: 18,
                            height: 18,
                          }}
                        />
                      </>
                    ) : (
                      <></>
                    )}
                    {product.discount === 0 ? <></> : <></>}
                    <div
                      style={{
                        display: "flex",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          width: "100%",
                        }}
                      >
                        {product.discount === 0 ? (
                          <div
                            style={{
                              display: "flex",
                              paddingRight: "50%",
                            }}
                          >
                            {product.priceInsteadOf === 0 ? (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  width: "100%",
                                  alignItems: "center",
                                }}
                              >
                                <p
                                  style={{
                                    margin: 0,
                                    //paddingBottom: 5,
                                    fontSize: 15,
                                  }}
                                >
                                  ₪
                                  {calculateTotalPrice(
                                    product.price,
                                    product.totalQuantity,
                                    product.discount,
                                    product.theDeal
                                  )}
                                </p>
                              </div>
                            ) : (
                              <>
                                <p
                                  style={{
                                    margin: 0,
                                    //paddingBottom: 5,
                                    fontSize: 15,
                                    color: "red",
                                    textDecoration: "line-through",
                                  }}
                                >
                                  ₪
                                  {calculateTotalPrice(
                                    product.price,
                                    product.totalQuantity,
                                    product.discount,
                                    product.theDeal
                                  )}
                                </p>
                                &nbsp;&nbsp;
                                <p
                                  style={{
                                    margin: 0,
                                    //paddingBottom: 5,
                                    fontSize: 15,
                                  }}
                                >
                                  ₪
                                  {calculateTotalPrice(
                                    product.priceInsteadOf,
                                    product.totalQuantity,
                                    product.discount,
                                    product.theDeal
                                  )}
                                </p>
                              </>
                            )}
                            <a
                              style={{
                                fontSize: 12,
                              }}
                            >
                              &nbsp;
                            </a>
                          </div>
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                              }}
                            >
                              {product.theDeal === 1 ? (
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                  }}
                                >
                                  <p
                                    style={{
                                      margin: 0,
                                      fontSize: 15,
                                      textDecoration: "line-through",
                                      color: "#a1a1aa",
                                    }}
                                  >
                                    ₪{product.price * product.totalQuantity}
                                  </p>
                                  &nbsp;&nbsp;
                                  <p
                                    style={{
                                      margin: 0,
                                      fontSize: 15,
                                    }}
                                  >
                                    ₪
                                    {(
                                      product.price -
                                      (product.price * product.discount) / 100
                                    ).toFixed(2) * product.totalQuantity}
                                  </p>
                                </div>
                              ) : (
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                  }}
                                >
                                  {product.totalQuantity === 1 ? (
                                    <></>
                                  ) : (
                                    <>
                                      <p
                                        style={{
                                          margin: 0,
                                          fontSize: 15,
                                          textDecoration: "line-through",
                                          color: "#a1a1aa",
                                        }}
                                      >
                                        ₪{product.price * product.totalQuantity}
                                      </p>
                                      &nbsp; &nbsp;
                                    </>
                                  )}
                                  <p
                                    style={{
                                      margin: 0,
                                      fontSize: 15,
                                    }}
                                  >
                                    ₪
                                    {calculateTotalPrice(
                                      product.price,
                                      product.totalQuantity,
                                      product.discount,
                                      product.theDeal
                                    )}
                                  </p>
                                </div>
                              )}
                            </div>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              &nbsp; &nbsp;
                              {product.theDeal === 1 ? (
                                <div>
                                  <p
                                    style={{
                                      backgroundColor: "#6b21a8",
                                      color: "white",
                                      margin: 0,
                                      fontSize: 12,
                                      padding: 4,
                                      paddingLeft: 10,
                                      paddingRight: 10,
                                    }}
                                  >
                                    -{product.discount}%
                                  </p>
                                </div>
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        width: "100%",
                        paddingRight: "5%",
                        justifyContent: "space-between",
                        paddingTop: 10,
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                        }}
                      >
                        {product.isGift != 2 ? (
                          <>
                            <button
                              title="minus"
                              style={{
                                padding: 5,
                                backgroundColor: "white",
                                border: "1px solid #e7e5e4",
                              }}
                            >
                              {
                                <img
                                  src={minusImage1}
                                  style={{
                                    width: 30,
                                    height: 30,
                                    margin: 0,
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    MinusAmountCart(
                                      product.cartIds[0],
                                      user?.userId,
                                      product.id
                                    );
                                  }}
                                />
                              }
                            </button>
                          </>
                        ) : (
                          <div style={{ width: 40 }}></div>
                        )}

                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <p
                            style={{
                              margin: 0,
                              paddingRight: 15,
                              paddingLeft: 15,
                            }}
                          >
                            {product.totalQuantity}
                          </p>
                        </div>

                        {product.isGift != 2 ? (
                          <>
                            <button
                              type="button" // Prevent default form behavior
                              title="plus"
                              style={{
                                padding: 5,
                                backgroundColor: "white",
                                border: "1px solid #e7e5e4",
                              }}
                              onClick={() => {
                                CreateProduct2(product.id);
                              }}
                            >
                              <img
                                src={plusImage1}
                                style={{
                                  width: 30,
                                  height: 30,
                                  margin: 0,
                                  cursor: "pointer",
                                }}
                              />
                            </button>
                          </>
                        ) : (
                          <></>
                        )}
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {product.isGift != 2 ? (
                          <>
                            <button
                              title="delete"
                              style={{
                                backgroundColor: "white",
                                border: "0px solid white",
                              }}
                            >
                              <img
                                src={deleteImage}
                                style={{
                                  width: 20,
                                  height: 20,
                                  margin: 0,
                                  opacity: hoverStates[product.id] ? 1 : 0.5,
                                }}
                                onClick={() => {
                                  DeleteFromCart(
                                    product.id,
                                    product.id,
                                    user?.userId,
                                    product.id
                                  );
                                }}
                                onMouseEnter={() =>
                                  handleMouseEnter(product.id)
                                }
                                onMouseLeave={() =>
                                  handleMouseLeave(product.id)
                                }
                              />
                            </button>
                          </>
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>
                    <div style={{ display: "flex" }}>
                      <p style={{ margin: 0, paddingTop: 10 }}>
                        <a
                          style={{
                            fontSize: 15,
                          }}
                        >
                          {product.theDeal === 1 ? (
                            <div></div>
                          ) : (
                            <div>
                              <p
                                style={{
                                  color: "#6b21a8",
                                  fontSize: 12,
                                  paddingLeft: 5,
                                  paddingRight: 5,
                                  border: "0.1px solid #e4e4e7",
                                  padding: 20,
                                }}
                              >
                                Buy 2 pcs to get -{product.discount}% off every{" "}
                                {product.theDeal}
                                {product.theDeal === 2 ? "nd" : "th"} item
                              </p>
                            </div>
                          )}
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "center",
                  }}
                >
                  <div
                    style={{
                      width: "90%",
                      backgroundColor: "#e4e4e7",
                      height: "1px",
                      marginTop: 15,
                    }}
                  ></div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <div
        style={{
          width: "100%",
          height: "auto",
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              width: "90%",
              backgroundColor: "#e4e4e7",
              height: "1px",
              marginTop: 20,
            }}
          ></div>
        </div>
        <div
          style={{
            display: "flex",
            width: "90%",
            paddingBottom: 20,
            paddingTop: 15,
          }}
        >
          {/* <a
            style={{
              fontSize: 14,
              color: "#6b21a8", // Change color on hover
              cursor: "pointer",
            }}
          >
            Choose gift wrapping
          </a> */}
        </div>
        <div
          style={{
            flexDirection: "row",
            display: "flex",
            width: "90%",
            alignItems: "center",
            justifyContent: "space-between",
            paddingBottom: 5,
          }}
        >
          <p style={{ margin: 0, fontSize: 14 }}>{t("profile.Subtotal")}</p>
          <p style={{ margin: 0, fontSize: 14 }}>
            ₪{SaveTotalPrice.toFixed(2)}
          </p>
        </div>

        <div
          style={{
            paddingBottom: 20,
            display: "flex",
            width: "90%",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              flexDirection: "row",
              display: "flex",
              width: "100%",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <p style={{ margin: 0, fontSize: 14 }}>{t("profile.Shipping")}</p>
            <p style={{ margin: 0, fontSize: 14 }}>
              {" "}
              {SaveTotalPrice > 299 ? <a>₪0</a> : <a>₪20</a>}
            </p>
          </div>
          {PromoCode2 === null ? (
            <></>
          ) : (
            <>
              <a style={{ margin: 0, fontSize: 14 }}>
                Used promo code:{" "}
                <a style={{ fontWeight: "500", fontSize: 16 }}>
                  {PromoCode2?.discount}%
                </a>
              </a>
            </>
          )}
        </div>
        <div
          style={{
            flexDirection: "row",
            display: "flex",
            width: "90%",
            alignItems: "center",
            justifyContent: "space-between",
            //paddingBottom: 20,
          }}
        >
          {/* const [UserExistInBeautyClub, setUserExistInBeautyClub] =
          useState(false); const [BeautyClubData, setBeautyClubData] =
          useState(""); */}
        </div>

        {UserExistInBeautyClub ? (
          <>
            <div
              style={{
                flexDirection: "row",
                display: "flex",
                width: "90%",
                alignItems: "center",
                justifyContent: "space-between",
                paddingBottom: 20,
              }}
            >
              <p style={{ margin: 0, fontSize: 14 }}>
                {" "}
                {t("profile.Beautyclubdiscount")}🌟
              </p>
              <p style={{ margin: 0, fontSize: 14 }}>
                {BeautyClubData.discount}%
              </p>
            </div>
            <div
              style={{
                flexDirection: "row",
                display: "flex",
                width: "90%",
                alignItems: "center",
                justifyContent: "space-between",
                paddingBottom: 20,
              }}
            >
              <p style={{ margin: 0, fontWeight: "bold", fontSize: 18 }}>
                {t("profile.GrandTotal")}
              </p>
              <p style={{ margin: 0, fontWeight: "bold", fontSize: 18 }}>
                {SaveTotalPrice < 200 ? (
                  <a>₪{(SaveGrandTotalPrice + 20).toFixed(2)}</a>
                ) : (
                  <a>₪{SaveGrandTotalPrice.toFixed(2)}</a>
                )}
              </p>
            </div>
          </>
        ) : (
          <>
            <div
              style={{
                flexDirection: "row",
                display: "flex",
                width: "90%",
                alignItems: "center",
                justifyContent: "space-between",
                paddingBottom: 20,
              }}
            >
              <p style={{ margin: 0, fontWeight: "bold", fontSize: 18 }}>
                {t("profile.GrandTotal")}
              </p>
              <p style={{ margin: 0, fontWeight: "bold", fontSize: 18 }}>
                {SaveTotalPrice < 200 ? (
                  <a>₪{(SaveGrandTotalPrice + 20).toFixed(2)}</a>
                ) : (
                  <a>₪{SaveGrandTotalPrice.toFixed(2)}</a>
                )}
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
